import { ALL_VERSIONS_TEXT } from 'app/developer-v3/constants';

const ALL_VERSIONS_LABEL = 'All versions';

const ALL_VERSIONS_OPTION = {
  label: ALL_VERSIONS_LABEL,
  value: ALL_VERSIONS_TEXT,
};

export { ALL_VERSIONS_LABEL, ALL_VERSIONS_OPTION };
